import angular from 'angular';

import './in_store/controller';
import './login/controller';
import './logout/controller';
import './okta/controller';
import './order/controller';
import './reset_ask/controller';
import './reset_confirm/controller';
import './settlement/controller';
import './merchant-admin/controller';

angular.module("merchant.application.page", [
]).controller("merchant.application.page.controller", [
    "$rootScope", "$scope",
    "merchant.application.main.factory.authentication",
    function($rootScope, $scope, Authentication) {

        $scope.model = {};
        $rootScope.headerMinor = [];
        $rootScope.headerPage = [];
        $scope.model.populating = false;
        $rootScope.fatalError = false;
        $rootScope.unauthorisedError = false;
        $rootScope.countryCode = Authentication.countryCode();

    }
]);
